export default __webpack_public_path__ + "static/replay-ca63914ea4f3aebf65247fe1482d2b56.png";